import React, { useContext } from 'react'
import ModalContext from '../ModalContext'

import { StyledModalHeader, CloseButton } from './styles'

const ModalHeader = ({ children, closeButton, ...rest }) => {
  const { handleOnClose } = useContext(ModalContext)

  return (
    <StyledModalHeader {...rest}>
      {children}
      {closeButton && <CloseButton onClick={handleOnClose}>⨯</CloseButton>}
    </StyledModalHeader>
  )
}

export default ModalHeader
